"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormBuilderWithoutStyles = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Button = _interopRequireDefault(require("../Button"));

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

var _FieldRenderer = _interopRequireDefault(require("../FieldRenderer"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _styles2 = require("./styles");

var _SnackBar = _interopRequireDefault(require("../SnackBar/SnackBar"));

var FormBuilder = function FormBuilder(props) {
  var _props$snackBarAnchor;

  var values = (0, _react.useRef)({});
  var errors = (0, _react.useRef)({});
  var dirty = (0, _react.useRef)(false);
  var components = (0, _react.useRef)({});

  var _useState = (0, _react.useState)({
    message: "",
    title: "",
    type: "none"
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];
  /**
   * Set initial values from the fields.
   */


  (0, _react.useEffect)(function () {
    props.fields.forEach(function (f) {
      if (values.current[f.name] == null && f.value != null) {
        values.current[f.name] = f.value;
      }
    });
  }, [props.fields]);
  var submit = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var options,
        hasError,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
              bypassValidation: false
            };
            setStatus({
              type: "saving",
              message: ""
            });

            if (options.bypassValidation) {
              _context.next = 9;
              break;
            }

            _context.next = 5;
            return Promise.all(props.fields.map(function (w) {
              return validate(w);
            }));

          case 5:
            hasError = _context.sent.find(function (w) {
              return w.error;
            });

            if (!hasError) {
              _context.next = 9;
              break;
            }

            setStatus({
              type: "error",
              message: "Please double check the field(s) and try again."
            });
            return _context.abrupt("return");

          case 9:
            return _context.abrupt("return", values.current);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [props.fields]);
  (0, _react.useEffect)(function () {
    var _props$onRef;

    var ref = {
      submit: submit
    };
    (_props$onRef = props.onRef) === null || _props$onRef === void 0 ? void 0 : _props$onRef.call(props, ref);
  }, [props.fields, props.fieldConfiguration, props.fieldMapper, submit, props.onRef]);

  var handleAction = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(event, action) {
      var _action$bypassValidat, _action$onComplete;

      var result, _response, skipToastNotification;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return submit({
                bypassValidation: (_action$bypassValidat = action.bypassValidateBeforeOnClick) !== null && _action$bypassValidat !== void 0 ? _action$bypassValidat : false
              });

            case 2:
              result = _context2.sent;

              if (result) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              _context2.prev = 5;
              _context2.next = 8;
              return action.onClick(event, values.current);

            case 8:
              _response = _context2.sent;
              skipToastNotification = props.disableNotifications ? true : _response && _response.skipToastNotification;

              if (!(_response === null || _response === void 0 ? void 0 : _response.error)) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", setStatus({
                type: "error",
                message: _response.error.title || "".concat(action.display, " failed!")
              }));

            case 12:
              if (skipToastNotification) {
                setStatus({
                  type: "none",
                  message: "",
                  title: ""
                });
              } else {
                setStatus({
                  type: "success",
                  title: (_response === null || _response === void 0 ? void 0 : _response.title) || "".concat(action.display, " succeeded!"),
                  message: _response === null || _response === void 0 ? void 0 : _response.message
                });
              }

              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](5);
              return _context2.abrupt("return", setStatus({
                type: "error",
                message: _context2.t0.message || "".concat(action.display, " failed!")
              }));

            case 18:
              (_action$onComplete = action.onComplete) === null || _action$onComplete === void 0 ? void 0 : _action$onComplete.call(action, values.current);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 15]]);
    }));

    return function handleAction(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var validate = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(field) {
      var _components$current$f;

      var component;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              component = (_components$current$f = components.current[field.name]) === null || _components$current$f === void 0 ? void 0 : _components$current$f.current;

              if (!(!component || !component.validate)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", {
                error: false,
                message: "",
                validationName: null
              });

            case 3:
              _context3.next = 5;
              return component.validate(values.current[field.name]);

            case 5:
              return _context3.abrupt("return", _context3.sent);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function validate(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var renderSaveActions = function renderSaveActions() {
    var id = props.id,
        saveActions = props.saveActions,
        buttonContainer = props.buttonContainer,
        buttonGroupAlignment = props.buttonGroupAlignment;
    var actions = saveActions;

    if (!actions) {
      return null;
    }

    var renderedButtonGroup = /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
      id: "".concat(id, "-action-button-group"),
      layout: buttonGroupAlignment
    }, actions && actions.length > 0 ? actions.map(function (action, actionIndex) {
      var htmlId = "".concat(id, "-saveActions-").concat(actionIndex);
      return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
        id: htmlId,
        key: htmlId,
        disabled: (variant === null || variant === void 0 ? void 0 : variant.toLowerCase()) === "readonly",
        onClick: function onClick(event) {
          return handleAction(event, action);
        }
      }, action.buttonProps), action.display);
    }) : undefined);

    return buttonContainer ? /*#__PURE__*/_reactDom.default.createPortal(renderedButtonGroup, buttonContainer) : renderedButtonGroup;
  };

  var onChange = function onChange(field, data) {
    var _props$onChange;

    values.current[field.name] = data;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, field, data);

    if (!dirty.current) {
      var _props$onDirtyState;

      dirty.current = true;
      (_props$onDirtyState = props.onDirtyState) === null || _props$onDirtyState === void 0 ? void 0 : _props$onDirtyState.call(props, true);
    }
  };

  var id = props.id,
      className = props.className,
      variant = props.variant;
  return /*#__PURE__*/_react.default.createElement("form", {
    id: id,
    className: "prmbl-formBuilder ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FieldRenderer.default, {
    id: "".concat(id),
    fields: props.fields,
    onChange: onChange,
    fieldConfiguration: props.fieldConfiguration,
    customValidations: props.customValidations,
    customToolbarButtons: props.customToolbarButtons,
    variant: variant,
    onFieldMounted: function onFieldMounted(field, component) {
      components.current[field.name] = component;
    },
    validate: validate,
    fieldMapper: props.fieldMapper,
    onValidation: function onValidation(field, result) {
      var _props$onValidation;

      if (result.error) {
        errors.current[field.name] = result;
      } else {
        delete errors.current[field.name];
      }

      (_props$onValidation = props.onValidation) === null || _props$onValidation === void 0 ? void 0 : _props$onValidation.call(props, field, result);
    }
  }), /*#__PURE__*/_react.default.createElement("div", null, !props.hideLoadingIndicator && (status === null || status === void 0 ? void 0 : status.type) === "saving" ? /*#__PURE__*/_react.default.createElement(_Loader.default, null) : renderSaveActions()), /*#__PURE__*/_react.default.createElement(_SnackBar.default, {
    id: "".concat(id, "-status-message"),
    anchorOrigin: (_props$snackBarAnchor = props.snackBarAnchorOrigin) !== null && _props$snackBarAnchor !== void 0 ? _props$snackBarAnchor : {
      horizontal: "center",
      vertical: "bottom"
    },
    autoHideDuration: 5000,
    message: {
      title: status.title,
      message: status.message,
      variant: status.type === "error" ? "error" : "success"
    },
    onClose: function onClose() {
      setStatus({
        message: "",
        title: "",
        type: "none"
      });
    },
    open: status.type === "success" || status.type === "error"
  }))));
};

exports.FormBuilderWithoutStyles = FormBuilder;
FormBuilder.defaultProps = {
  className: "",
  classes: {
    fieldWrapper: {}
  },
  buttonGroupAlignment: "right",
  variant: "editable",
  disableNotifications: false
};

var _default = (0, _styles.withStyles)(_styles2.styles)(FormBuilder);

exports.default = _default;